module.exports = __webpack_public_path__ + "img/lev2.443a9386.png";